import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class RedirectToLoginGuard implements CanActivate {
  constructor(public authService: AuthService) {}

  public canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.authService.navigateToLoginPage();
      return false;
    }

    return true;
  }
}
